import { Outlet } from "react-router";

import { AnalyticsBridge } from "@/components/analytics-bridge";
import { ConsentBanner } from "@/components/consent-banner";

export function RootLayout() {
	return (
		<>
			<AnalyticsBridge />
			<Outlet />
			<ConsentBanner />
		</>
	);
}
